import clsx from "clsx";
import { ReactComponent as Facebook } from "../../../../assets/images/socials/facebook.svg";
import { ReactComponent as Instagram } from "../../../../assets/images/socials/instagram.svg";
import { ReactComponent as LinkedIn } from "../../../../assets/images/socials/linkedin.svg";
import { ReactComponent as Twitter } from "../../../../assets/images/socials/twitter.svg";
import { ReactComponent as Telegram } from "../../../../assets/images/socials/telegram.svg";

import classes from "./Social.module.scss";

type PropsType = {
  type: string;
  href?: string;
};

const Social = (
  props: PropsType & React.AnchorHTMLAttributes<HTMLAnchorElement>
) => {
  const { type, className, ...rest } = props;

  let component: JSX.Element;

  switch (type) {
    case "facebook":
      component = <Facebook />;
      break;
    case "instagram":
      component = <Instagram />;
      break;
    case "twitter":
      component = <Twitter />;
      break;
    case "linkedin":
      component = <LinkedIn />;
      break;
    case "telegram":
      component = <Telegram />;
      break;

    default:
      component = <div></div>;
  }

  return (
    <a className={clsx(classes.social, className)} {...rest} rel="noreferrer">
      {component}
    </a>
  );
};

export default Social;
